import {
  Box,
  ButtonGroup,
  HStack,
  Stack,
  Table,
  TableContainer,
  Tag,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import ButtonRemoveResource from 'components/ButtonRemoveResource';
import ButtonEdit from 'components/ui/ButtonEdit';
import CompanyHeader from 'components/ui/CompanyHeader';
import { useSearchParams } from 'react-router-dom';
import { useListsByCompanies } from '../hooks/useListsByCompanies';

export default function ListsCompanyView() {
  const [searchParams] = useSearchParams();
  const companies = useListsByCompanies();

  if (!companies) return null;

  return (
    <Stack spacing="50px">
      {companies.map((company) => (
        <Box key={`company-${company.id}`}>
          <CompanyHeader
            company={company}
            description={`${company.lists.length} listas`}
          />
          <TableContainer mt="23px">
            <Table>
              <Thead>
                <Tr>
                  <Th>Nome da lista</Th>
                  <Th w="150px">Lista de newsletter / Revisão</Th>
                  <Th w="650px">Tags</Th>
                  <Th w="160px"></Th>
                </Tr>
              </Thead>
              <Tbody>
                {company.lists.map((list) => (
                  <Tr key={`row-${list.id}`}>
                    <Td>{list.name}</Td>
                    <Td>
                      {list.isNewsletter
                        ? `Sim / ${list.requiresReview ? 'Sim' : 'Não'}`
                        : 'Não'}
                    </Td>
                    <Td>
                      <HStack spacing="8px" flexWrap="wrap">
                        {list.tags.map((tag) => (
                          <Tag
                            key={`tag-${tag.id}`}
                            colorScheme={tag.colorScheme}
                          >
                            {tag.name}
                          </Tag>
                        ))}
                      </HStack>
                    </Td>
                    <Td textAlign="right">
                      <ButtonGroup>
                        <ButtonEdit
                          to={`/listas-de-disparo/${list.id}${searchParams.size > 0 ? `?${searchParams}` : ''}`}
                        />
                        <ButtonRemoveResource
                          id={list.id}
                          pathName="lists"
                          queryKey="search-lists"
                        />
                      </ButtonGroup>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      ))}
    </Stack>
  );
}
